// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5pZoX","button":"styles_button__rBoz2"};